export const chartColors = [
  //https://neoground.com/docs/neowx-material/config.charts
  // Palette 3 # subarray (0-4)
  "#33b2df",
  "#546e7a",
  "#d4526e",
  "#13d8aa",
  "#a5978b",
  // Palette 5 # subarray (5-9)
  "#2b908f",
  "#f9a3a4",
  "#90ee7e",
  "#f48024",
  "#69d2e7",
  // Palette 7 # subarray (10-14)
  "#d7263d",
  "#1b998b",
  "#2e294e",
  "#f46036",
  "#e2c044",
  // Palette 9 # subarray (15-19)
  "#5c4742",
  "#a5978b",
  "#8d5b4d",
  "#5a2a27",
  "#c4bbaf",
  // Palette 1
  "#775dd0",
  // Palette 2
  "#4caf50",
  "#ff9800",
  // Palette 4
  "#34ecdc4",
  "#fd6a6a",
  // Palette 6
  "#f86624",
  "#662e9b",
  "#c5d86d",
  // Palette 10
  "#a300d6",
  "#5653fe",
];

const chartDefault = "#33b2df";

export const colors = {
  chartDefault,
  sessions: "#008ffb", // "#f9c80e",
  views: chartDefault,
  ca: "#feb019", // "#f44336",
  rpm: "#4caf50",
  objective: "#d7263d",
  accomplished: "#5c4742",
  green: "#e3ffc3",
  orange: "#feddaa",
  red: "#ffdfdd",
};

export const noDataText = "Aucune donnée disponible";
export const dataLoadingText = "Données en cours de réception...";
export const DATA_LOADING_ALTERNATIVE_TEXTS = [
  "Un peu de patience, ça arrive...",
  "On y est presque...",
  "Encore un petit instant...",
];

export const NOTIF_DISPLAY_DURATION = 5000;

export const NEWS_RADAR_CRAWLER_DAGS = [
  "news_radar_concurrency_dag",
  "news_radar_rss_app_dag",
  "news_radar_others_dag",
  "news_radar_youtube_dag",
  "news_radar_marfeel_dag",
];

// Sources NRD qui ne sont plus enregistrees dans news_radar_data : les
// selectionner dans un filtre ne rend plus jamais rien. Elles restent affichees
// comme sources complementaires d'un angle, ou elles sont construites en memoire.
// Les libelles sont ceux d'apres mapping, tels que SourceFilter les compare
// (cf. SOURCE_DISPLAYABLE_TEXTS dans news-radar/common/filters/SourceFilter.vue).
export const NEWS_RADAR_EXTERNAL_SOURCES = ["Google News", "Perplexity"];

// Support d'une config de veille (`news_radar_config.media_type`, T5). Le
// support est porte par la CONFIG et non par la source : c'est ce qui permet de
// suivre un meme compte Instagram en ecrit ET en video.
export const NEWS_RADAR_MEDIA_TYPES = [
  { value: "written", text: "Écrit" },
  { value: "video", text: "Vidéo" },
];

export const NEWS_RADAR_MEDIA_TYPE_LABELS = {
  written: "Écrit",
  video: "Vidéo",
};

// Les seules sources dont la chaine de transcription sait tirer une video
// (common/transcription/routing.py : youtube, instagram, tiktok, x). Typer une
// config Marfeel ou Reddit en video enverrait un payload Discover ou un fil de
// commentaires chez yt-dlp.
export const NEWS_RADAR_VIDEO_SOURCES = [
  "Youtube",
  "Instagram (via RssApp)",
  "X (via RssApp)",
  "Tiktok (via RssApp)",
];

export const URL_PARAM_NAMES = {
  AdUnitFilter: "a_dUnits",
  AifAutoConfigFilter: "aif_auto_config",
  AgeFilter: "age",
  AudienceType: "audienceType",
  CategoryFilter: "categories",
  ChannelFilter: "channels",
  CohortFilter: "cohorts",
  CostFilter: "cost",
  DateFilter: "dates",
  DateFrequency: "frequency",
  DeviceFilter: "devices",
  DishFilter: "dish",
  DurationFilter: "duration",
  EvolutionFilter: "evolutions",
  ExportFilter: "export",
  FinanceMappingEntityFilter: "mappingEntity",
  FinanceMappingReplaceFilter: "mappingReplace",
  FinanceMappingSearchFilter: "mappingSearch",
  FinanceMappingSourceFilter: "mappingSource",
  FlavourFilter: "flavour",
  GroupCaFilter: "groupCa",
  GroupByMonthFilter: "groupByMonth",
  IngredientFilter: "ingredients",
  IngredientToExcludeFilter: "ingredientToExclude",
  UtensilFilter: "utensils",
  MetricFilter: "metrics",
  PageTypeFilter: "pageTypes",
  PartnerViewFilter: "partnerViews",
  PartnerViewGroupFilter: "partnerViewGroups",
  PeriodFilter: "period",
  PeriodTypeFilter: "periodType",
  // PlacementFilter: "placements",
  PositionFilter: "positions",
  RatesFilter: "rates",
  RatingFilter: "rating",
  RedacFilter: "redacs",
  RegionFilter: "region",
  Search: "search",
  SearchColumn: "searchColumn",
  SearchType: "searchType",
  SexFilter: "sex",
  SiteFilter: "sites",
  SiteGroupFilter: "siteGroups",
  // TargetingPresetFilter: "targetingPresets"
  TextFilter: "searchText",
  ThresholdFilter: "threshold",
  ToExclude: "toExclude",
  updateYear: "year",
};

export const zIndex = {
  modale: 202,
};
